import { render, staticRenderFns } from "./ImageUploadInput.vue?vue&type=template&id=0f04a07c&scoped=true"
import script from "./ImageUploadInput.vue?vue&type=script&lang=js"
export * from "./ImageUploadInput.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadInput.vue?vue&type=style&index=0&id=0f04a07c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04a07c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f04a07c')) {
      api.createRecord('0f04a07c', component.options)
    } else {
      api.reload('0f04a07c', component.options)
    }
    module.hot.accept("./ImageUploadInput.vue?vue&type=template&id=0f04a07c&scoped=true", function () {
      api.rerender('0f04a07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/ImageUploadInput.vue"
export default component.exports